import microApp from '@micro-zoe/micro-app'
import * as config from './config'

microApp.start({
  preFetchApps: config.MICRO_APPS,
  globalAssets: config.default,
})

microApp.setData('authCommon', {
  product: 'iKG',
  theme: {
    colorPrimary: '#0087E1',
    colorLink: '#0087E1',
  },
})
